import { Box, Typography } from '@mui/material'

import Item from '@ecm/ui/component/menu/Item'
import Color from '@ecm/ui/element/Color'

import checkIcon from '/public/images/icon/check.svg'
import integrationsIcon from '/public/images/icon/integrations.svg'
import mailIcon from '/public/images/icon/mail-forwarding.svg'
import paperIcon from '/public/images/icon/paper-shredding.svg'
import phoneIcon from '/public/images/icon/phone.svg'
import scanIcon from '/public/images/icon/scan.svg'

const content = [
  {
    heading: 'Check Deposit',
    href: '/check-deposit',
    icon: checkIcon,
  },
  {
    heading: 'Mail Scanning',
    href: '/mail-scanning',
    icon: scanIcon,
  },
  {
    heading: 'Mail Forwarding',
    href: '/mail-forwarding',
    icon: mailIcon,
  },
  {
    heading: 'Secure Shredding',
    href: '/mail-shredding',
    icon: paperIcon,
  },
  {
    heading: 'Integrations',
    href: '/integrations',
    icon: integrationsIcon,
  },
  {
    heading: 'Mobile Apps',
    href: '/mobile',
    icon: phoneIcon,
  },
]

const Features = () => (
  <Box
    borderLeft={{ md: `1px solid ${Color.smoke.darker}`, xs: 'none' }}
    p={{ md: '0 0.5em 0 1.5em', xs: '2em 1em 1em' }}
  >
    <Typography variant="overline" mb="1.5em" color={Color.saint.lighter}>
      Features
    </Typography>
    {content.map(({ heading, href, icon }) => (
      <Box key={heading} mb={{ md: '0', xs: '0.5em' }} width={{ md: '310px' }}>
        <Item href={href} icon={icon} heading={heading} features />
      </Box>
    ))}
  </Box>
)

export default Features
